import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { Button } from "@mui/material";
import useAuth from "../../../hooks/useAuth";
import { apiVariable } from "../../../api/apiVariable";
import GenericFormPopup from "../GenericFormPopup/GenericFormPopup";
import StatusSnackbar from "../../General/StatusSnackbar/StatusSnackbar";
import {
  companyFieldConfiguration,
  companyInitialValues,
} from "../../../formConfigs/Fleet/companyFieldConfig";

const CompanyPopup = () => {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const queryClient = useQueryClient();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSnackbarClose = () => setStatus("idle");

  const { token } = useAuth();

  const companyMutation = useMutation({
    mutationFn: (data: any) =>
      axios.post(`${apiVariable}/ownerCompany`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    onSuccess: () => {
      setStatus("success");
      queryClient.invalidateQueries({ queryKey: ["companies"] });
      queryClient.invalidateQueries({ queryKey: ["ownerCompanies"] });
      handleClose();
    },
    onError: (error: any) => {
      setStatus("error");
      setErrorMessage(error.response.data || "Failed to submit company");
    },
  });

  const submitHandler = (data: any) => {
    companyMutation.mutate(data);
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Add Company
      </Button>
      <GenericFormPopup
        formFields={companyFieldConfiguration}
        initialValues={companyInitialValues}
        title="Company Form"
        onSubmit={submitHandler}
        open={open}
        onClose={handleClose}
        loading={companyMutation.isPending}
      />
      <StatusSnackbar
        status={status}
        successMessage="Company created successfully"
        errorMessage={errorMessage}
        handleClose={handleSnackbarClose}
      />
    </>
  );
};

export default CompanyPopup;
